@if (isContentLoaded) {
  <div class="ql-editor">
    <fieldset class="my-nexus-default-fieldset" id="welcome-view">
      <div class="default-padding">
        <h3 class="leading-tight mb-4">Welcome {{ userName }}</h3>
        <p [innerHTML]="contentPage['welcome'] | safeHtml"></p>
        @if ((contentPage['updates'] | stripHtml).length) {
          <fieldset
            class="my-nexus-alert-fieldset red-border"
            >
            <legend class="my-nexus-default-legend hidden"></legend>
            <p [innerHTML]="contentPage['updates'] | safeHtml"></p>
          </fieldset>
        }
        @if ((contentPage['provider'] | stripHtml).length) {
          <fieldset
            class="my-nexus-alert-fieldset orange-border"
            >
            <legend class="my-nexus-default-legend hidden"></legend>
            <p [innerHTML]="contentPage['provider'] | safeHtml"></p>
          </fieldset>
        }
        <p [innerHTML]="contentPage['additional'] | safeHtml"></p>
      </div>
      <div class="">
        @if ((contentPage['forms'] | stripHtml).length) {
          <fieldset
            class="my-nexus-default-fieldset mt-4"
            >
            <legend class="my-nexus-default-legend">
              Forms
            </legend>
            <p [innerHTML]="contentPage['forms'] | safeHtml"></p>
          </fieldset>
        }
        @if ((contentPage['manuals'] | stripHtml).length) {
          <fieldset
            class="my-nexus-default-fieldset mt-4"
            >
            <legend class="my-nexus-default-legend">
              Provider Manuals & Appeal Information
            </legend>
            <p [innerHTML]="contentPage['manuals'] | safeHtml"></p>
          </fieldset>
        }
      </div>
    </fieldset>
  </div>
}
